import React from "react";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-surface-raised border-t border-black/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          {/* Brand */}
          <div className="md:col-span-5">
            <Link to="/" className="inline-block mb-5">
              <span className="text-xl font-medium tracking-tight text-ink">
                Apply<span className="text-brand">Strat</span>
              </span>
            </Link>
            <p className="text-ink-secondary text-sm leading-relaxed max-w-xs">
              Strategic tech job applications through official company portals. We handle the applications so you can focus on becoming ready to win the role.
            </p>
            <a
              href="mailto:hello@applystrat.com"
              data-testid="footer-email"
              className="inline-flex items-center gap-2 mt-5 text-brand text-sm font-medium hover:text-brand-hover transition-colors"
            >
              <Mail size={14} />
              hello@applystrat.com
            </a>
            <a
              href="mailto:manideep@applystrat.com"
              data-testid="footer-email-manideep"
              className="inline-flex items-center gap-2 mt-2 text-ink-secondary text-sm font-medium hover:text-ink transition-colors"
            >
              <Mail size={14} />
              manideep@applystrat.com
            </a>
            <a
              href="https://chat.whatsapp.com/FXDjBtdoTOE2mOHjBcSHmT"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-community"
              className="inline-flex items-center gap-2 mt-4 px-4 py-2 rounded-full bg-[#25D366]/10 text-[#25D366] text-sm font-medium hover:bg-[#25D366]/20 transition-colors"
            >
              <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
              Join WhatsApp Community
            </a>
          </div>

          <div className="md:col-span-3 md:col-start-7">
            <h4 className="text-ink font-medium text-xs uppercase tracking-widest mb-5">Service</h4>
            <ul className="space-y-3">
              {[
                { href: "/how-it-works", label: "How It Works" },
                { href: "/who-we-help", label: "Who We Help" },
                { href: "/why-us", label: "Why Us" },
                { href: "/faq", label: "FAQ" },
                { href: "/apply", label: "Apply Now" },
              ].map((l) => (
                <li key={l.href}>
                  <Link to={l.href} className="text-ink-secondary text-sm hover:text-ink transition-colors">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-ink font-medium text-xs uppercase tracking-widest mb-5">Resources</h4>
            <ul className="space-y-3">
              {[
                { href: "/blog", label: "Blog" },
                { href: "/resume-optimizer", label: "Resume Optimizer" },
                { href: "/blog/10-prompts-fix-resume", label: "10 Resume Prompts" },
              ].map((l) => (
                <li key={l.href}>
                  <Link to={l.href} className="text-ink-secondary text-sm hover:text-ink transition-colors">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-black/5 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-ink-secondary text-xs">© {year} ApplyStrat. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <Link to="/privacy" className="text-ink-secondary text-xs hover:text-ink transition-colors">Privacy</Link>
            <Link to="/terms" className="text-ink-secondary text-xs hover:text-ink transition-colors">Terms</Link>
            <p className="text-ink-secondary text-xs">For serious tech candidates in India & the US.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
